// firmenKommunikationService.ts — geschäftliches Telefon / geschäftliche E-Mail
// einer Person MIT Firmenbezug zu einer bestimmten Firma sofort speichern
// (Liste „Mensch im Unternehmen" und Popup „Verantwortung fürs Unternehmen",
// User 30.09.2026).
//
// Gibt es die Zeile schon (id aus contactToRelationItems.kommunikationVon), wird
// genau sie geändert (PUT). Sonst wird eine NEUE Zeile angelegt (POST) — eine
// andere Nummer der Person (privat, Handy, andere Firma) wird nie überschrieben.
// Das Recht prüft das Backend an der Person (`assertContactWritable`).

import { apiFetch } from "../utils/apiFetch";

export type FirmenKommunikationTyp = "phone" | "email";

export type FirmenKommunikationSpeichern = {
  personId: number;
  firmaId: number;
  typ: FirmenKommunikationTyp;
  /** Schon formatiert (Telefon: Speicherwert von telefonVerlassen). */
  wert: string;
  /** id der bestehenden geschäftlichen Zeile zu dieser Firma, sonst null. */
  vorhandenId?: number | null;
};

/** Legt an bzw. ändert; wirft bei HTTP-Fehler (ApiFetchError mit `status`). */
export async function firmenKommunikationSpeichern(args: FirmenKommunikationSpeichern): Promise<void> {
  const headers = { "Content-Type": "application/json" };
  if (args.vorhandenId) {
    // Nur der Wert: Die Zeile gehört dieser Firma schon — und vielleicht noch
    // weiteren (seit 02.10.2026). Ein mitgeschicktes companyId ersetzte deren
    // Liste durch diese eine Firma.
    const body = JSON.stringify({ type: args.typ, value: args.wert.trim() });
    await apiFetch(`contact/${args.personId}/communication/${args.vorhandenId}`, { method: "PUT", headers, body });
  } else {
    // Neu: Gibt es dieselbe Nummer schon, vereinigt der Server die Firmen.
    const body = JSON.stringify({
      type: args.typ,
      value: args.wert.trim(),
      kind: "geschaeftlich",
      companyIds: [args.firmaId],
    });
    await apiFetch(`contact/${args.personId}/communication`, { method: "POST", headers, body });
  }
}

/** Verständliche Meldung zu einem gescheiterten Sofort-Speichern. */
export function sofortFehlerText(e: unknown, was: string): string {
  const status = (e as { status?: number } | null)?.status;
  if (status === 403) return `${was}: Sie haben keine Berechtigung, diese Person zu ändern.`;
  if (status === 400) return `${was}: Der Wert wurde nicht angenommen.`;
  return `${was} konnte nicht gespeichert werden.`;
}
